import { FC } from 'react';
import { H2 } from 'atoms/Typography';
import styles from './styles.module.css';

export const Subtitle: FC<{ text: string }> = ({ text }) => {
  return <H2 className={styles.subTitle}>{text}</H2>;
};
